// import React, { useEffect, useState } from "react";
// import { db } from "../firebase";
// import {
//   collection,
//   addDoc,
//   getDocs,
//   updateDoc,
//   deleteDoc,
//   doc,
// } from "firebase/firestore";
// import { useParams } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const TrainingQuestions = () => {
//   const { trainingId } = useParams();
//   const [questions, setQuestions] = useState([]);
//   const [text, setText] = useState("");
//   const [correctAnswer, setCorrectAnswer] = useState(true);
//   const [currentId, setCurrentId] = useState(null);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     fetchQuestions();
//   }, []);

//   const fetchQuestions = async () => {
//     const querySnapshot = await getDocs(collection(db, `trainings/${trainingId}/questions`));
//     setQuestions(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       if (currentId) {
//         await updateDoc(doc(db, `trainings/${trainingId}/questions`, currentId), { text, answer: correctAnswer });
//         toast.success("Question updated successfully!");
//       } else {
//         await addDoc(collection(db, `trainings/${trainingId}/questions`), { text, answer: correctAnswer });
//         toast.success("Question added successfully!");
//       }
//       resetForm();
//       fetchQuestions();
//     } catch (error) {
//       toast.error("Error adding/updating question: " + error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEdit = (question) => {
//     setText(question.text);
//     setCorrectAnswer(question.answer);
//     setCurrentId(question.id);
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this question?")) {
//       await deleteDoc(doc(db, `trainings/${trainingId}/questions`, id));
//       toast.success("Question deleted successfully!");
//       fetchQuestions();
//     }
//   };

//   const resetForm = () => {
//     setText("");
//     setCorrectAnswer(true);
//     setCurrentId(null);
//   };

//   return (
//     // <div>
//     //   <h1>Manage Questions for Training</h1>
//     //   <form onSubmit={handleSubmit}>
//     //     <input
//     //       type="text"
//     //       placeholder="Enter question"
//     //       value={text}
//     //       onChange={(e) => setText(e.target.value)}
//     //       required
//     //     />
//     //     <label>
//     //       Correct Answer:
//     //       <select value={correctAnswer} onChange={(e) => setCorrectAnswer(e.target.value === "true")}>
//     //         <option value="true">True</option>
//     //         <option value="false">False</option>
//     //       </select>
//     //     </label>
//     //     <button type="submit" disabled={loading}>
//     //       {loading ? "Loading..." : currentId ? "Update Question" : "Add Question"}
//     //     </button>
//     //   </form>
//     //   <ul>
//     //     {questions.map((question) => (
//     //       <li key={question.id}>
//     //         <p>{question.text} (Correct Answer: {question.answer ? "True" : "False"})</p>
//     //         <button onClick={() => handleEdit(question)}>Edit</button>
//     //         <button onClick={() => handleDelete(question.id)}>Delete</button>
//     //       </li>
//     //     ))}
//     //   </ul>
//     //   <ToastContainer position="top-right" autoClose={5000} hideProgressBar />
//     // </div>

// <div className="container mt-3">
//   <h2>Manage Questions for Training</h2>
//   <form onSubmit={handleSubmit} className="mb-3">
//     <input
//       type="text"
//       placeholder="Enter question"
//       value={text}
//       onChange={(e) => setText(e.target.value)}
//       required
//       className="form-control"
//     />
//     <label className="d-block mt-2">
//       Correct Answer:
//       <select
//         value={correctAnswer}
//         onChange={(e) => setCorrectAnswer(e.target.value === "true")}
//         className="form-select mt-2"
//       >
//         <option value="true">True</option>
//         <option value="false">False</option>
//       </select>
//     </label>
//     <button type="submit" disabled={loading} className="btn btn-primary mt-2">
//       {loading ? "Loading..." : currentId ? "Update Question" : "Add Question"}
//     </button>
//   </form>

//   <table className="table table-striped">
//     <thead>
//       <tr>
//         <th>Question</th>
//         <th>Correct Answer</th>
//         <th>Actions</th>
//       </tr>
//     </thead>
//     <tbody>
//       {questions.map((question, index) => (
//         <tr key={question.id}>
//           <td>{index + 1}. {question.text}</td>
//           <td>{question.answer ? "True" : "False"}</td>
//           <td>
//             <button
//               onClick={() => handleEdit(question)}
//               className="btn btn-warning btn-sm me-2"
//             >
//               Edit
//             </button>
//             <button
//               onClick={() => handleDelete(question.id)}
//               className="btn btn-danger btn-sm"
//             >
//               Delete
//             </button>
//           </td>
//         </tr>
//       ))}
//     </tbody>
//   </table>

//   <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
// </div>


//   );
// };

// export default TrainingQuestions;



// import React, { useEffect, useState } from "react";
// import { db } from "../firebase";
// import {
//   collection,
//   addDoc,
//   getDocs,
//   updateDoc,
//   deleteDoc,
//   doc,
// } from "firebase/firestore";
// import { useParams } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const TrainingQuestions = () => {
//   const { trainingId } = useParams();
//   const [questions, setQuestions] = useState([]);
//   const [text, setText] = useState("");
//   const [type, setType] = useState("true_false"); // true_false or mcq
//   const [correctAnswer, setCorrectAnswer] = useState(true); // For True/False
//   const [options, setOptions] = useState(["", "", "", ""]); // For MCQ
//   const [correctOption, setCorrectOption] = useState(null); // For MCQ
//   const [currentId, setCurrentId] = useState(null);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     fetchQuestions();
//   }, []);

//   const fetchQuestions = async () => {
//     const querySnapshot = await getDocs(collection(db, `trainings/${trainingId}/questions`));
//     setQuestions(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // Data validation
//     if (!text.trim()) {
//       toast.error("Question text is required.");
//       setLoading(false);
//       return;
//     }

//     let questionData = { text, type };

//     if (type === "true_false") {
//       questionData = { ...questionData, answer: correctAnswer };
//     } else if (type === "mcq") {
//       if (options.some((option) => !option.trim())) {
//         toast.error("All options must be filled.");
//         setLoading(false);
//         return;
//       }
//       if (correctOption === null) {
//         toast.error("Please select the correct option.");
//         setLoading(false);
//         return;
//       }
//       questionData = { ...questionData, options, correctOption };
//     }

//     try {
//       if (currentId) {
//         await updateDoc(doc(db, `trainings/${trainingId}/questions`, currentId), questionData);
//         toast.success("Question updated successfully!");
//       } else {
//         await addDoc(collection(db, `trainings/${trainingId}/questions`), questionData);
//         toast.success("Question added successfully!");
//       }
//       resetForm();
//       fetchQuestions();
//     } catch (error) {
//       toast.error("Error adding/updating question: " + error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEdit = (question) => {
//     setText(question.text);
//     setType(question.type);
//     if (question.type === "true_false") {
//       setCorrectAnswer(question.answer);
//     } else if (question.type === "mcq") {
//       setOptions(question.options);
//       setCorrectOption(question.correctOption);
//     }
//     setCurrentId(question.id);
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this question?")) {
//       await deleteDoc(doc(db, `trainings/${trainingId}/questions`, id));
//       toast.success("Question deleted successfully!");
//       fetchQuestions();
//     }
//   };

//   const resetForm = () => {
//     setText("");
//     setType("true_false");
//     setCorrectAnswer(true);
//     setOptions(["", "", "", ""]);
//     setCorrectOption(null);
//     setCurrentId(null);
//   };

//   const resetFormFields = () => {
//     if (type === "mcq") {
//       setCorrectAnswer(true); // Reset True/False specific field
//     } else {
//       setOptions(["", "", "", ""]); // Reset MCQ specific fields
//       setCorrectOption(null);
//     }
//   };
  

//   return (
//     <div className="container mt-3">
//       <h2>Manage Questions for Training</h2>
//       <form onSubmit={handleSubmit} className="mb-3">
//         <input
//           type="text"
//           placeholder="Enter question"
//           value={text}
//           onChange={(e) => setText(e.target.value)}
//           required
//           className="form-control mb-2"
//         />

//         {/* Question Type Selector */}
//         <label className="d-block mt-2">
//           Question Type:
//           <select
//             value={type}
//             onChange={(e) => {
//               setType(e.target.value);
//               resetFormFields();
//             }}
//             className="form-select mt-2"
//           >
//             <option value="true_false">True/False</option>
//             <option value="mcq">Multiple Choice</option>
//           </select>
//         </label>

//         {/* True/False Input */}
//         {type === "true_false" && (
//           <label className="d-block mt-2">
//             Correct Answer:
//             <select
//               value={correctAnswer}
//               onChange={(e) => setCorrectAnswer(e.target.value === "true")}
//               className="form-select mt-2"
//             >
//               <option value="true">True</option>
//               <option value="false">False</option>
//             </select>
//           </label>
//         )}

//         {/* MCQ Input */}
//         {type === "mcq" && (
//           <>
//             {options.map((option, index) => (
//               <div key={index} className="input-group mb-2">
//                 <span className="input-group-text">Option {index + 1}</span>
//                 <input
//                   type="text"
//                   value={option}
//                   onChange={(e) => {
//                     const updatedOptions = [...options];
//                     updatedOptions[index] = e.target.value;
//                     setOptions(updatedOptions);
//                   }}
//                   className="form-control"
//                   required
//                 />
//                 <input
//                   type="radio"
//                   name="correctOption"
//                   checked={correctOption === index}
//                   onChange={() => setCorrectOption(index)}
//                   className="form-check-input ms-2"
//                 />
//               </div>
//             ))}
//           </>
//         )}

//         {/* Submit Button */}
//         <button type="submit" disabled={loading} className="btn btn-primary mt-2">
//           {loading ? "Loading..." : currentId ? "Update Question" : "Add Question"}
//         </button>
//       </form>


//       <table className="table table-striped">
//         <thead>
//           <tr>
//             <th>Question</th>
//             <th>Type</th>
//             <th>Details</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {questions.map((question, index) => (
//             <tr key={question.id}>
//               <td>{index + 1}. {question.text}</td>
//               <td>{question.type === "true_false" ? "True/False" : "MCQ"}</td>
//               <td>
//                 {question.type === "true_false" ? (
//                   <>
//                     <strong>Answer:</strong> {question.answer ? "True" : "False"}
//                   </>
//                 ) : (
//                   <>
//                     <strong>Options:</strong>
//                     <ul>
//                       {question.options.map((option, idx) => (
//                         <li key={idx}>{option}</li>
//                       ))}
//                     </ul>
//                     <strong>Correct:</strong> {question.options[question.correctOption]}
//                   </>
//                 )}
//               </td>
//               <td>
//                 <button
//                   onClick={() => handleEdit(question)}
//                   className="btn btn-warning btn-sm me-2"
//                 >
//                   Edit
//                 </button>
//                 <button
//                   onClick={() => handleDelete(question.id)}
//                   className="btn btn-danger btn-sm"
//                 >
//                   Delete
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
//     </div>
//   );
// };

// export default TrainingQuestions;






























import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  getDoc,
} from "firebase/firestore";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TrainingQuestions = () => {
  const { trainingId } = useParams();
  const [trainingType, setTrainingType] = useState(null); // Training type: true_false or mcq
  const [questions, setQuestions] = useState([]);
  const [text, setText] = useState("");
  const [type, setType] = useState("true_false"); // Type for adding questions
  const [correctAnswer, setCorrectAnswer] = useState(true); // For True/False
  const [options, setOptions] = useState(["", "", ""]); // For MCQ
  const [correctOption, setCorrectOption] = useState(null); // For MCQ
  const [currentId, setCurrentId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchTrainingType();
    fetchQuestions();
  }, []);

  // Fetch the training type from Firestore
  const fetchTrainingType = async () => {
    const trainingDoc = await getDoc(doc(db, "trainings", trainingId));
    if (trainingDoc.exists()) {
      setTrainingType(trainingDoc.data().type || null);
    }
  };

  // Fetch questions for the training
  const fetchQuestions = async () => {
    const querySnapshot = await getDocs(collection(db, `trainings/${trainingId}/questions`));
    setQuestions(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
  };

  // Set the training type if not already set
  const setTrainingTypeHandler = async (type) => {
    try {
      await updateDoc(doc(db, "trainings", trainingId), { type });
      setTrainingType(type);
      toast.success(`Training type set to ${type === "true_false" ? "True/False" : "MCQs"}`);
    } catch (error) {
      toast.error("Failed to set training type: " + error.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!trainingType) {
      toast.error("Please set the training type before adding questions.");
      setLoading(false);
      return;
    }

    let questionData = { text, type: trainingType };

    if (trainingType === "true_false") {
      questionData = { ...questionData, answer: correctAnswer };
    } else if (trainingType === "mcq") {
      if (options.some((option) => !option.trim())) {
        toast.error("All options must be filled.");
        setLoading(false);
        return;
      }
      if (correctOption === null) {
        toast.error("Please select the correct option.");
        setLoading(false);
        return;
      }
      questionData = { ...questionData, options, correctOption };
    }

    try {
      if (currentId) {
        await updateDoc(doc(db, `trainings/${trainingId}/questions`, currentId), questionData);
        toast.success("Question updated successfully!");
      } else {
        await addDoc(collection(db, `trainings/${trainingId}/questions`), questionData);
        toast.success("Question added successfully!");
      }
      resetForm();
      fetchQuestions();
    } catch (error) {
      toast.error("Error adding/updating question: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (question) => {
    setText(question.text);
    if (trainingType === "true_false") {
      setCorrectAnswer(question.answer);
    } else if (trainingType === "mcq") {
      setOptions(question.options);
      setCorrectOption(question.correctOption);
    }
    setCurrentId(question.id);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this question?")) {
      await deleteDoc(doc(db, `trainings/${trainingId}/questions`, id));
      toast.success("Question deleted successfully!");
      fetchQuestions();
    }
  };

  const resetForm = () => {
    setText("");
    setCorrectAnswer(true);
    setOptions(["", "", ""]);
    setCorrectOption(null);
    setCurrentId(null);
  };

  return (
    <div className="container mt-3">
      <h2>Manage Questions for Training</h2>

      {!trainingType && (
        <div className="mb-3">
          <p>Please set the training type before adding questions:</p>
          <button
            onClick={() => setTrainingTypeHandler("true_false")}
            className="btn btn-secondary me-2"
          >
            True/False
          </button>
          <button
            onClick={() => setTrainingTypeHandler("mcq")}
            className="btn btn-secondary"
          >
            MCQs
          </button>
        </div>
      )}

      {trainingType && (
        <>
          <form onSubmit={handleSubmit} className="mb-3">
            <input
              type="text"
              placeholder="Enter question"
              value={text}
              onChange={(e) => setText(e.target.value)}
              required
              className="form-control mb-2"
            />

            {/* True/False Input */}
            {trainingType === "true_false" && (
              <label className="d-block mt-2">
                Correct Answer:
                <select
                  value={correctAnswer}
                  onChange={(e) => setCorrectAnswer(e.target.value === "true")}
                  className="form-select mt-2"
                >
                  <option value="true">True</option>
                  <option value="false">False</option>
                </select>
              </label>
            )}

            {/* MCQ Input */}
            {trainingType === "mcq" && (
              <>
                {options.map((option, index) => (
                  <div key={index} className="input-group mb-2">
                    <span className="input-group-text">Option {index + 1}</span>
                    <input
                      type="text"
                      value={option}
                      onChange={(e) => {
                        const updatedOptions = [...options];
                        updatedOptions[index] = e.target.value;
                        setOptions(updatedOptions);
                      }}
                      className="form-control"
                      required
                    />
                    <input
                      type="radio"
                      name="correctOption"
                      checked={correctOption === index}
                      onChange={() => setCorrectOption(index)}
                      className="form-check-input ms-2"
                    />
                  </div>
                ))}
              </>
            )}

            <button type="submit" disabled={loading} className="btn btn-primary mt-2">
              {loading ? "Loading..." : currentId ? "Update Question" : "Add Question"}
            </button>
          </form>

          <table className="table table-striped">
            <thead>
              <tr>
                <th>Question</th>
                <th>Details</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {questions.map((question, index) => (
                <tr key={question.id}>
                  <td>{index + 1}. {question.text}</td>
                  <td>
                    {trainingType === "true_false" ? (
                      <>
                        <strong>Answer:</strong> {question.answer ? "True" : "False"}
                      </>
                    ) : (
                      <>
                        <strong>Options:</strong>
                        <ul>
                          {question.options.map((option, idx) => (
                            <li key={idx}>{option}</li>
                          ))}
                        </ul>
                        <strong>Correct:</strong> {question.options[question.correctOption]}
                      </>
                    )}
                  </td>

                  <td>
                    <button
                      onClick={() => handleEdit(question)}
                      className="btn btn-warning btn-sm me-2"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(question.id)}
                      className="btn btn-danger btn-sm"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
    </div>
  );
};

export default TrainingQuestions;

